import { render } from "./MyBoxes.vue?vue&type=template&id=250c22a5&scoped=true"
import script from "./MyBoxes.vue?vue&type=script&lang=js"
export * from "./MyBoxes.vue?vue&type=script&lang=js"

import "./MyBoxes.vue?vue&type=style&index=0&id=250c22a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250c22a5"]])

export default __exports__